<div class="navbar-box row m-0 justify-content-between">
    <div class="col-auto d-flex align-content-center align-items-center justify-content-start p-0">
        <div class="navbar-box__toggler" (click)="toggleSideMenu()" click-stop-propagation>
            <nb-icon icon="menu-2-outline" class="cursor-pointer">
            </nb-icon>
        </div>
        <div class="navbar-box__logo cursor-pointer noSelect" [routerLink]='["/dashboard"]'>
            <img *ngIf="!isPro()" class="navbar-box__logo-img" src="assets/logo_pandora.png" alt="Logo Roboze" />
            <img *ngIf="isPro()" class="navbar-box__logo-img" src="assets/logo_pandora_pro.png" alt="Logo Roboze" />
        </div>
    </div>
    <div class="navbar-box__menu col-auto text-right d-flex justify-content-end align-items-center">
        <div *ngIf="!isMobile" class="menu__roboze">
            <button aria-label="Roboze" (click)="openRobozeMainPage()">
                <nb-icon icon="globe-outline" aria-hidden="true"></nb-icon>
            </button>
        </div>
        <div class="menu__notification-bell">
            <button class="notification-bell__icon cursor-pointer" aria-label="Notification" (click)="toggleNotificationsMenu()" click-stop-propagation>
                <nb-icon icon="bell-outline" aria-hidden="true"></nb-icon>
                <span *ngIf="numberOfNotifications !== 0" [hidden]="hideBadge">
                    <nb-badge *ngIf="numberOfNotifications > 0 && numberOfNotifications < 100" text="{{numberOfNotifications}}" status="danger" position="top right"></nb-badge>
                    <nb-badge *ngIf="numberOfNotifications > 99" text="99+" status="danger" position="top right"></nb-badge>
                </span>
            </button>
        </div>
        <div class="menu__user dropdown" *ngIf="currentUser">
            <app-user-avatar [avatarUrl]="baseAvatarUrl + 'avatars/' + currentUser.avatar"
                             [userFullName]="currentUser.firstName + ' ' + currentUser.lastName"
                             [cursorPointer]="true"
                             id="dropdownContextMenu"
                             data-bs-toggle="dropdown"
                             >
            </app-user-avatar>
            <div id="context-menu" class="dropdown-menu" aria-labelledby="dropdownContextMenu" #contextMenu>
                <app-context-menu [currentUser]="currentUser"
                                  [baseAvatarUrl]="baseAvatarUrl">
                </app-context-menu>
            </div>
        </div>
    </div>
</div>
<app-notification-menu #notificationsMenu></app-notification-menu>